import * as React from "react"
import { Link } from "gatsby"

import { isLocalLink } from "@lib/utils"

const SafeLink = ({ url, activeClassName, forceInternal, ...props }) => {
  if (!url) {
    return null
  }

  const isOutsideLink = !isLocalLink(url)
  const isInternalDownload = url.includes("/assets/")
  const notInternalLink =
    isOutsideLink ||
    isInternalDownload ||
    url.startsWith("tel") ||
    url.startsWith("mailto")

  if (notInternalLink) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        href={url}
        {...(isOutsideLink &&
          !forceInternal && {
            target: "_blank",
            rel: "noopener noreferrer",
          })}
        {...(isInternalDownload && {
          download: true,
        })}
        {...props}
      />
    )
  }

  return <Link to={url} activeClassName={activeClassName} {...props} />
}

export default SafeLink
